// src/api/client.js
import axios from 'axios'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE || '/api',
  withCredentials: false,
})

// gắn token từ localStorage cho mọi request
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('ctv_token')
  if (t) cfg.headers.Authorization = `Bearer ${t}`
  return cfg
})

export function setToken(t) {
  if (t) localStorage.setItem('ctv_token', t)
  else localStorage.removeItem('ctv_token')
}
